import i18n from '@/locales/index'
// import TIM from 'tim-js-sdk';
import TIM from '@tencentcloud/chat';
import TIMUploadPlugin from 'tim-upload-plugin';
import store from '@/store/index';
import TitleWink from '@/utils/title-wink';
import * as $http from '@/axios';
import notify, { requestPermission } from '@/utils/web-notification';
import { MessageBox } from 'element-ui';
import $util from '@/utils/util';
import { imCall } from '../utils/imcall';
// import { imCall } from '@/utils/imcall'
import VoiceRoomIM from '@/components/VoiceRoom/voiceRoomIM';

const options = {
  SDKAppID: process.env.VUE_APP_IM_SDK_ID
};

const REVEICE_MESSAGE = {
  newOrders: [],
  command: null
};

const tim = TIM.create(options);

VoiceRoomIM.initTim(tim);

let voice = null;

const titleWinkInstance = new TitleWink();

let IM_READY_RS;

// eslint-disable-next-line
const IM_READY = new Promise(res => {
  IM_READY_RS = function() {
    res();
  };
});

// tim.setLogLevel(process.env.NODE_ENV === 'production' ? 1 : 0)
tim.setLogLevel(4);
tim.registerPlugin({ 'tim-upload-plugin': TIMUploadPlugin });
// tim.registerPlugin({'cos-js-sdk': COS})

// 更新用户资料
const updateUserProfile = () => {
  const userInfo = store.state.app.userInfo;
  if (!userInfo) return;

  tim.updateMyProfile({
    nick: userInfo.nickname,
    avatar: userInfo.avatarUrl,
    allowType: TIM.TYPES.ALLOW_TYPE_ALLOW_ANY
  });
};

// 更新IM SDK状态
const sdkReady = async () => {
  await store.dispatch('im/setSdkReady', {
    status: true,
    instance: tim
  });
  IM_READY_RS();
  updateUserProfile();
};

// IM 離線
const sdkLogout = async () => {
  await store.dispatch('im/setSdkReady', {
    status: false,
    instance: null
  });
  const isChatPage =
    location.pathname.indexOf('/chat/') !== -1 ||
    location.pathname.indexOf('/voice-room/') !== -1 ||
    location.pathname.indexOf('/game-room/') !== -1;
  console.log(
    'sdkLogout',
    isChatPage,
    location.pathname.indexOf('/voice-room/')
  );
  if (isChatPage) {
    imSdkInit();
  }
};

// 更新会话列表
const updateConversationList = ({ data }) => {
  data = data.filter(item => {
    return item && item.userProfile && item.userProfile.userID !== 'commander';
  });
  const unreadCount = data.reduce((total, current) => {
    // if (current.lastMessage && current.lastMessage.payload && current.lastMessage.payload.description === 'OrderStatusChange') return total
    return (total += current.unreadCount);
  }, 0);
  const selectedConversation = store.state.im.selectedConversation;
  const initPageConversation = store.state.im.initChatUser;

  if (selectedConversation) {
    const index = data.findIndex(
      item =>
        item.userProfile.userID === selectedConversation.userProfile.userID
    );
    if (index === -1) {
      data.unshift(selectedConversation);
    } else {
      store.commit('im/UPDATE_SELECTED_CONVERSATION', data[index]);
    }

    if (initPageConversation) {
      if (
        initPageConversation.userProfile.userID !==
        selectedConversation.userProfile.userID
      ) {
        const index = data.findIndex(
          item =>
            item.userProfile.userID === initPageConversation.userProfile.userID
        );

        if (index === -1) {
          data.unshift(initPageConversation);
        } else {
          store.commit('im/UPDATE_INIT_CHAT_USER', data[index]);
        }
      } else if (selectedConversation.conversationID) {
        store.commit('im/UPDATE_INIT_CHAT_USER', selectedConversation);
      }
    }
  }

  if (unreadCount < store.state.im.unreadCount) {
    titleWinkInstance.clear();
  }
  if (store.state.im.sdkReady) {
    store.dispatch('im/updateConversationList', data);
    store.dispatch('im/updateUnreadCount', unreadCount);
  } else {
    IM_READY.then(() => {
      store.dispatch('im/updateConversationList', data);
      store.dispatch('im/updateUnreadCount', unreadCount);
    });
  }
};

// 接收消息
const receivedMessage = ({ data }) => {
  const conversation = store.state.im.selectedConversation;
  const messageList = store.state.im.messageListMap;
  let commanderMsg = null;
  const receiveMessage = data.filter(item => {
    if (item.flow === 'out') {
      return false;
    }
    if (item.from === 'commander') {
      commanderMsg = item;
      return false;
    }
    return true;
  });
  if (commanderMsg) {
    // 系统消息
    const { conversationID } = commanderMsg;
    tim.setMessageRead({ conversationID });
    if (REVEICE_MESSAGE.command) {
      REVEICE_MESSAGE.command(commanderMsg);
    }
  }
  const orderRemindMessage = receiveMessage.filter(msg => {
    if (msg.payload.description !== 'OrderStatusChange') return false;
    const msgObj = JSON.parse(msg.payload.data);
    if (msgObj.status === 'Effective') return true;
    return false;
  });
  // const notContainOrderRemindMessage = receiveMessage.filter(msg => msg.payload.description !== 'OrderStatusChange')
  const notContainOrderRemindMessage = receiveMessage;
  // const newMessageList = []
  // 获取自己发送出去的消息和接收的信息
  const userInfo = store.state.app.userInfo;
  data.forEach(item => {
    if (item.from !== 'commander' && conversation) {
      if (conversation.userProfile.userID === item.from) {
        tim.setMessageRead({ conversationID: conversation.conversationID });

        messageList.push({
          payload: item.payload,
          type: item.type,
          time: item.time,
          fromUuid: item.from,
          avatar: conversation.userProfile.avatar
        });
      } else if (conversation.userProfile.userID === item.to) {
        messageList.push({
          payload: item.payload,
          type: item.type,
          time: item.time,
          fromUuid: item.from,
          avatar: userInfo.avatarUrl,
          isSelf: true
        });
      }
    }
  });

  // 将订单提醒的未读清0
  // orderRemindMessage.forEach(msg => {
  //   tim.setMessageRead({ conversationID: msg.conversationID })
  // })

  // messageList.push(...newMessageList)
  store.dispatch('im/updateMessageList', messageList);

  if (receiveMessage.length && !window.opener) {
    if (!voice) {
      voice = document.querySelector('#voice-system');
    }

    if (!voice.paused) {
      voice.pause();
    }
    voice.muted = false;
    voice.currentTime = 0;
    voice.play();
  }
  const isChatPage = location.pathname.indexOf('/chat/') !== -1;
  if (notContainOrderRemindMessage.length && isChatPage) {
    titleWinkInstance.init(notContainOrderRemindMessage.length);
  }

  if (REVEICE_MESSAGE.newOrders.length && orderRemindMessage.length) {
    if (!isChatPage) {
      titleWinkInstance.init(orderRemindMessage.length, i18n.t('plugins_im_1949'));
    }
    REVEICE_MESSAGE.newOrders.forEach(func => {
      func(orderRemindMessage).then(() => {
        titleWinkInstance.clear();
      });
    });
  }
};

/**
 * @description: 处理接收消息
 */
function receivedHandle(data) {
  imCallHandle(data);
  if(location.pathname.indexOf('/voice-room') !== -1 || location.pathname.indexOf('/game-room') !== -1) {
    VoiceRoomIM.onMessageReceived(data);
  }
  if (data.data.every(item => ['GROUP'].includes(item.conversationType)))
    return;
  receivedMessage(data);
  systemNotify(data);
}

/**
 * @description: im调用执行方法处理
 * @param {*}
 * @return {*}
 */
function imCallHandle({ data }) {
  if (!Array.isArray(data)) return;
  data.forEach(item => {
    let handleData = $util.getVal(item, 'payload.data');
    try {
      handleData = JSON.parse(handleData);
    } catch (e) {
      handleData = false;
    }
    if (!handleData) return;
    const params = {
      type: handleData.Command,
      data: handleData.ExtraData
    };
    if (params.type) {
      imCall(params);
    }
  });
}
/**
 * @description: 發送im通知
 */
async function systemNotify({ data }) {
  await requestPermission(alertOpen);
  const userInfo = store.state.app.userInfo || {};
  let isSelf = true;
  const orderRemindMessage = data.filter(msg => {
    if (msg.from * 1 != userInfo.uuid) {
      isSelf = false;
    }
    if (msg.payload.description !== 'OrderStatusChange') return false;
    const msgObj = JSON.parse(msg.payload.data);
    if (msgObj.status === 'Effective') return true;
    return false;
  });
  if (isSelf) return;
  // 訂單im消息
  if (orderRemindMessage.length) {
    notify(i18n.t('plugins_im_1950')).then(notification => {
      notification.onclick = () => {
        $util.openChatWindow(userInfo.uuid);
      };
    });
    return;
  }
  // 特殊im消息
  let description = data[0]._elements[0].content.description;
  if (description === 'Command') {
    let commandData = JSON.parse(data[0]._elements[0].content.data);
    let { msg, url } = commandData.ExtraData;
    if (!msg) return;
    notify(msg).then(notification => {
      notification.onclick = () => {
        $util.openWindow(url);
      };
    });
    return;
  }
  // 普通im
  let text = data[0]._elements[0].content.text;
  notify(i18n.t('plugins_im_1951'), { body: text }).then(notification => {
    notification.onclick = () => {
      $util.openChatWindow(userInfo.uuid);
    };
  });
}

function alertOpen() {
  let openTime = localStorage.getItem('web_im_push') || 0;
  let nowTime = new Date().getTime();
  if (nowTime - openTime < 7 * 24 * 3600 * 1000) {
    return false;
  } else {
    localStorage.setItem('web_im_push', nowTime);
  }
  return MessageBox.confirm(
    i18n.t('plugins_im_1952'),
    {
      confirmButtonText: i18n.t('plugins_im_1953'),
      cancelButtonText: i18n.t('plugins_im_1954')
    }
  )
    .then(() => {
      return true;
    })
    .catch(() => {
      return false;
    });
}

const sdkError = err => {
  throw err;
};

tim.on(TIM.EVENT.SDK_READY, () => {
  sdkReady();
  VoiceRoomIM.sdkReady();
});

tim.on(TIM.EVENT.SDK_NOT_READY, sdkLogout);

tim.on(TIM.EVENT.MESSAGE_RECEIVED, receivedHandle);

tim.on(TIM.EVENT.CONVERSATION_LIST_UPDATED, updateConversationList);

tim.on(TIM.EVENT.ERROR, sdkError);

const imSdkLogout = async () => {
  if (!store.state.im.sdkReady) return;

  const userInfo = store.state.app.userInfo;
  const localStorageekey = `TIM_${process.env.VUE_APP_IM_SDK_ID}_${userInfo.uuid}_conversationMap`;

  await tim.logout();
  localStorage.removeItem(localStorageekey);
};

const setImReLogin = data => {
  setTimeout(async () => {
    console.log(
      'setImReLogin',
      location.pathname,
      location.pathname.indexOf('/voice-room/')
    );
    const isChatPage =
      location.pathname.indexOf('/chat/') !== -1 ||
      location.pathname.indexOf('/voice-room/') !== -1 ||
      location.pathname.indexOf('/game-room/') !== -1 ;
    if (!isChatPage && store.state.im.sdkReady) {
      const userInfo = store.state.app.userInfo;
      imSdkLogout();
      await tim.login({ userID: userInfo.uuid, userSig: data });
    }

    setImReLogin(data);
  }, 5000);
};

const imSdkInit = () => {
  console.log('imSdkInit', store.state.im.sdkReady);
  if (store.state.im.sdkReady) return;

  $http.get('/im/auth/sign').then(({ data }) => {
    const userInfo = store.state.app.userInfo;
    tim.login({ userID: userInfo.uuid, userSig: data }).then(() => {
      // setImReLogin(data);
    });
  });
};

const imRegisterNewOrders = func => {
  if (REVEICE_MESSAGE.newOrders.findIndex(fn => fn === func) === -1) {
    REVEICE_MESSAGE.newOrders.push(func);
  }
};

const imRegisterCommand = func => {
  if (!REVEICE_MESSAGE.command) {
    REVEICE_MESSAGE.command = func;
  }
};

export default {
  tim,
  imSdkInit,
  imSdkLogout,
  imRegisterNewOrders,
  imRegisterCommand,
  TYPES: TIM.TYPES
};
